module.exports = __webpack_public_path__ + "img/violet_025.90cbe148.png";